import { formControl } from '@al00x/forms';
import { Component, inject, signal } from '@angular/core';
import { Validators } from '@angular/forms';
import { PageEditorComponent, PageEditorData, TermsConditionService } from '@core';
import { TermsAndConditionsType } from '@models';
import { Observable } from 'rxjs';

@Component({
  selector: 'lib-delivery-info',
  templateUrl: './delivery-info.component.html',
  styleUrl: './delivery-info.component.css',
  imports: [PageEditorComponent],
  standalone: true,
})
export class DeliveryInfoComponent {
  readonly termsConditionService = inject(TermsConditionService);
  readonly type = TermsAndConditionsType.DeliveryInformation;
  isLoadingData = signal(true);
  
  pageEditorData: PageEditorData = {
    arabic: { controller: formControl<string>(undefined, Validators.required), title: 'معلومات التسليم' },
    english: { controller: formControl<string>(undefined, Validators.required), title: 'Delivery Information' },
  };

  constructor() {
    this.termsConditionService
      .getTermsAndConditionForAdmin(this.type)
      .subscribe({
        next: (res) => {
          this.pageEditorData.arabic.controller.setValue(res.termsAndConditionsDTO.arabicValue);
          this.pageEditorData.english.controller.setValue(res.termsAndConditionsDTO.englishValue);
          this.isLoadingData.set(false);
        },
        error: (error) => {
          console.error('Error loading delivery info data:', error);
          snackbar$.error('Error loading delivery info data');
          this.isLoadingData.set(false);
        }
      });
  }

  updateFunction = (): Observable<string> => {
      return this.termsConditionService.updateTermsAndConditions({
        type: this.type,
        value: {
          arabic: this.pageEditorData.arabic.controller.value,
          english: this.pageEditorData.english.controller.value,
        },
      });
    }
}
